const getClientList = state => state.clientList
const getClientSelected = state => state.clientSelected

export default {
  getClientList,
  getClientSelected,
};



// WEBPACK FOOTER //
// ./src/store/modules/client/getters.js